import { render } from "./Nav.vue?vue&type=template&id=e47e3c04"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"
script.render = render

export default script